import {authHeader} from '../_helpers';
import {handleResponse} from '../_helpers';


export const statusService = {
    createStatus,
    getStatusCollection,
    editStatus
};

function createStatus(data) {
    const header = authHeader();
    header['Content-Type'] = 'application/merge-patch+json';
    const requestOptions = {
        method: 'POST',
        headers: header,
        body: JSON.stringify(data)
    };

    return fetch(process.env.VUE_APP_API_SERVER+`/api/statuses`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function editStatus(data) {
    const header = authHeader();
    header['Content-Type'] = 'application/merge-patch+json';
    const requestOptions = {
        method: 'PATCH',
        headers: header,
        body: JSON.stringify(data)
    };

    return fetch(process.env.VUE_APP_API_SERVER+`/api/statuses`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function getStatusCollection() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(process.env.VUE_APP_API_SERVER+`/api/statuses`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}